module.exports = __webpack_public_path__ + "img/keyboard-arrow-return.de4e9cc9.svg";